var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "1365 93.95 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1365 106.9a13 13 0 1 1 0 .1z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.5 106.902a12.5 12.5 0 1 1 0 .096z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#bf0a76",
    fill: "transparent",
    strokeWidth: 0.96154
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1374.464 103.465 7.071 7.07",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#bf0a76",
    fill: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1381.535 103.465-7.07 7.07",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#bf0a76",
    fill: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.4ea49dce309e63f3d8c4b2bd5978ba3f.svg";
export { ForwardRef as ReactComponent };